import { faEdit, faPlusSquare } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { OPTIONS_DATA_MAPPER } from "../../utils";
import AddToolTip from "../AddToolTip";
import "../../styles/components/AddressDetails.scss";
import { getStateTax } from "../../services";
import { isEmpty, isEqual, isMatch, pick } from "lodash";
import { useDeepEffect } from "../../abstracts";

const keys = [
  "checkPayableTo",
  "address1",
  "city",
  "state",
  "country",
  "zipCode",
  "mobileNumber",
  "primaryEmailAddress",
];

const AddressDetails = (props) => {
  const {
    address,
    setAddress,
    addressList,
    defaultaddress,
    additionalAddressInformation,
    checked,
    setAddressSlideOpen,
    index,
    responseModel,
    addressAdded,
    setAddressAdded,
    data,
    module,
    setFieldValue,
    stateList,
    values,
    withdrawalTransactionId,
    isLoanRequest = false,
    selectedAddressInitialValue = 0,
  } = props;
  const [selectedAddress, setSelectedAddress] = useState(
    selectedAddressInitialValue
  );
  //   address?.findIndex((x) => x.id == 0)
  // );
  const checkIfDefault = (apiAddress) => {
    if (address.length >= 1) {
      if (isMatch(pick(address[0], keys), pick(apiAddress, keys))) return true;
    }
    return false;
  };
  const uniqueIds = [];
  const uniqueaddress = address.filter((element) => {
    const isDuplicate = uniqueIds.includes(element.checkPayableTo);
    if (!isDuplicate) {
      uniqueIds.push(element.checkPayableTo);
      return true;
    }
    return false;
  });

  var addressObj = uniqueaddress;

  useDeepEffect(() => {
    if (
      !isEmpty(responseModel) &&
      !isEmpty(responseModel[0]?.address && !isLoanRequest)
    ) {
      if (!checkIfDefault(responseModel[0]?.address)) {
        if (!isEmpty(addressList) && !isEmpty(addressList[index])) {
          addressList[index] = [
            addressList[index][0],
            responseModel[0]?.address,
          ];
          setSelectedAddress(1);
        } else {
          addressList[index] = [responseModel[0]?.address];
        }
        setAddress(addressList);
      }
    }
  }, [responseModel]);

  const onAddressChange = (val, ind) => {
    if (!isLoanRequest) {
      let id;
      if (val.stateId) {
        id = val.stateId;
      } else {
        let i = stateList?.findIndex((x) =>
          x.stateDescription == responseModel ? val.address.state : val.state
        );
        id = stateList[i].id;
      }

      module == "distribution" &&
        !isEmpty(id) &&
        getStateTax(id)
          .then((response) => {
            response.isStateWithholdingApplicable &&
              setFieldValue(
                `[${module}]${index}.stateTax`,
                response.defaultvalue
              );
          })
          .catch((error) => {
            //Handle Error
          });

      setFieldValue(`[${module}]${index}.address`, val);
      // setFieldValue(`[distribution]${index}.[address]['withdrawalTransactionId']`, withdrawalTransactionId);
    } else {
      setFieldValue(`address`, val);
    }

    setSelectedAddress(ind);
  };

  return (
    <div className="W-90 mb-15">
      <div className="d-flex flex-row mb-1">
        <p className="mb-0 p-0 ft-14 fw-400 Grey-Color">Address</p>
        &nbsp;&nbsp;&nbsp;
        {address.length <= 1 && (
          <div
            onClick={() => {
              if (isLoanRequest) setAddressSlideOpen(true);
              else setAddressSlideOpen(index);
            }}
            className="ft-14 fw-400 Light-Blue"
          >
            <FontAwesomeIcon icon={faPlusSquare} className="ft-14 fw-300" /> Add
          </div>
        )}
      </div>

      {addressObj?.map((val, ind) => (
        <div className="mb-15">
          <div
            className={`${
              ind == selectedAddress
                ? "border-blue background-blue"
                : "border-grey background-white"
            }${"d-flex flex-row align-items-center space-between W-100 H-64 b-1 br-5 mb-15"}`}
            style={{ cursor: "pointer" }}
            onClick={() => onAddressChange(val, ind)}
          >
            <input
              className=" m-10-10 w-10"
              style={{ width: "5%" }}
              checked={selectedAddress == ind}
              type="radio"
              name={`[${module}]${index}.address`}
              value={""}
              onChange={() => {
                // setFieldValue(`[distribution]${index}.addressId`, val.id);
              }}
            />
            <div
              style={{
                width: "35%",
                height: "100%",
                borderLeft: "0.5px solid #bdbdbd",
                borderRight: "0.5px solid #bdbdbd",
                //paddingTop: "15px",
                padding: "12px 0px 0px 15px",
              }}
            >
              <p
                style={{
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "#777777",
                  margin: "0px",
                }}
              >
                Check Payable To{" "}
              </p>
              <p
                style={{
                  fontWeight: "400",
                  fontSize: "14px",
                  color: "#000000",
                }}
              >
                <AddToolTip name={val.checkPayableTo} />
              </p>
            </div>
            <div
              style={{
                width: "60%",
                height: "100%",
                padding: "10px 0px 0px 15px",
              }}
            >
              <p className="ft-14 fw-400 " style={{ color: "#000000" }}>
                <AddToolTip
                  className={"address"}
                  name={`${val.address1 && val.address1}, ${
                    val.address2 ? val.address2 + "," : " "
                  } ${val.address3 ? val.address3 + "," : " "} ${
                    val?.city + ", "
                  }`}
                />
                {(val.countryId == 1 ? val.state : val.foreignState) +
                  ", " +
                  (val.countryId == 1 ? val.zipCode : val.foreignZipCode) +
                  ", " +
                  (val.countryId == 1 ? val.country : val.foreignCountry)}
                {/* {val.address1 && val.address1 + ", "}
                {val.address2 && val.address2 + ", "}
                {val.address3 && val.address3 + ", "}
                {val.city +
                  ", " +
                  (val.countryId == 1 ? val.state : val.foreignState) +
                  ", " +
                  (val.countryId == 1 ? val.zipCode : val.foreignZipCode) +
                  ", " +
                  (val.countryId == 1 ? val.country : val.foreignCountry)} */}
                {/* {val.phoneNumber}
                {val.primaryEmailAddress} */}
              </p>{" "}
            </div>{" "}
          </div>
          <div>
            {ind === 1 && (
              <div
                onClick={() => {
                  if (isLoanRequest) setAddressSlideOpen(true);
                  else setAddressSlideOpen(index);
                }}
                className="ft-14 fw-400 light-blue cursor-pointer"
              >
                <FontAwesomeIcon
                  icon={faEdit}
                  className="ft-14 fw-300 cursor-pointer"
                />{" "}
                Edit
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddressDetails;
